var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterTwoAddress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.72674 9.72741C8.93173 9.72741 9.90856 8.75057 9.90856 7.54559C9.90856 6.3406 8.93173 5.36377 7.72674 5.36377C6.52176 5.36377 5.54492 6.3406 5.54492 7.54559C5.54492 8.75057 6.52176 9.72741 7.72674 9.72741Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2725 7.15385C14.2725 12.6923 7.72709 17 7.72709 17C7.72709 17 1.18164 12.6923 1.18164 7.15385C1.18164 5.52174 1.87125 3.95649 3.09876 2.80242C4.32627 1.64835 5.99113 1 7.72709 1C9.46306 1 11.1279 1.64835 12.3554 2.80242C13.5829 3.95649 14.2725 5.52174 14.2725 7.15385Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTwoAddress);
export default __webpack_public_path__ + "static/media/footer-two-address.846278cfb0ba93a3badb71f5907bf04b.svg";
export { ForwardRef as ReactComponent };